import React from 'react';

import './index.css'

export default class Recaptcha extends React.Component {
    CAPTCHA_SITE_KEY = "6LetcxwTAAAAADqMNJtSZ1H_YEUZrmK-ygQofI4t";

    componentDidMount() {
        if (typeof window.grecaptcha.render === 'function') {
            window.grecaptcha.render('g-recaptcha', {
                'sitekey' : this.CAPTCHA_SITE_KEY,
                'callback' : this.handleClick.bind(this)
            }); 
        } else {
            this.handleClick("true");
        }
    }

    handleClick(token) {
    	this.props.validateCaptcha(token);
    }

	render() {
		return(
			<div className="recaptcha">
                <div id="g-recaptcha" />
            </div>
		)
	}
}
